import { createAction, props } from '@ngrx/store';
import { AttachmentsResponse } from '../../model/attachments.model';
import AppError from '../../model/app-error';

export enum AttachmentsActions {
  Reset = '[Attachments] Reset',
  FetchStart = '[Attachments] Fetch Start',
  FetchSuccess = '[Attachments] Fetch Success',
  FetchError = '[Attachments] Fetch Error',
  AddDownloadedFile = '[Attachments] Add Downloaded File',
}

const reset = createAction(AttachmentsActions.Reset);
const fetchStart = createAction(AttachmentsActions.FetchStart, props<{ processKind: string; hashCode?: string }>());
const fetchSuccess = createAction(AttachmentsActions.FetchSuccess, props<{ data: AttachmentsResponse }>());
const fetchError = createAction(AttachmentsActions.FetchError, props<{ error: AppError | null }>());
const addDownloadedFile = createAction(AttachmentsActions.AddDownloadedFile, props<{ url: string }>());

const attachmentsActions = {
  reset,
  fetchStart,
  fetchSuccess,
  fetchError,
  addDownloadedFile,
};

export default attachmentsActions;
